
import { contacts } from "../../models/model";
import { ContactActions } from "../interface/reducerType";

import {Types} from '../action/action';

const initialState=  {
  workContacts:  [],
  teamContacs:[],
  allContacs:[],
  workContactsnew:{},
  teamContacsnew:[],
  isTeamContactLoading:false,
  allContacsLoading: false,
  allContactsNew : [],
  favContacts: [],
  teamValidation : false,
  jenkinMessage: false,
  deleteContacts:[],
  temporyContact:[],
  temporyTeamContact:[]
};



export const contactReducer = (state: contacts = initialState, action: ContactActions) => {
  switch (action.type) {
  case Types.WORK_CONTACT:
    return {
      ...state, workContacts: action.payload.workContacts
    };
    case Types.WORK_CONTACT_GET:
      return {
        ...state, workContactsnew: action.payload.workContactsnew
      };
      case Types.ALL_CONTACT_LOADING:
        return {
          ...state, allContacsLoading:action.payload.allContacsLoading
        };    
  case Types.TEAM_CONTACT:
    return {
      ...state, isTeamContactLoading:action.payload.isTeamContactLoading, 
      teamContacs: action.payload.teamContacs
    };
    case Types.TEAM_CONTACT_NEW:
    return {
      ...state, isTeamContactLoading:action.payload.isTeamContactLoading, 
      teamContacsnew: action.payload.teamContacsnew
    };
  case Types.ALL_CONTACT:
    return {
      ...state, allContacs: action.payload.allContacs
    };
   case Types.ALL_CONTACT_NEW:
      return {
        ...state, allContactsNew: action.payload.allContactsNew
      };   
   case Types.UPDATE_ALL_CONTACTS:
        return {
          ...state, allContactsNew: action.payload.allContactsNew,
          teamContacsnew:action.payload.teamContacsnew,
          teamContacs:action.payload.teamContacs,
          workContacts: action.payload.workContacts,
          workContactsnew:action.payload.workContactsnew,
          allContacs:action.payload.allContacs

      }; 
      case Types.FAV_CONTACT:
    return {
      ...state, favContacts: action.payload.favContacts
    };
    case Types.TEAM_VALIDATION:
      return {
        ...state, teamValidation: action.payload.teamValidation
      };
      case Types.JENKINS_MESSAGE:
        return {
          ...state, jenkinMessage: action.payload.jenkinMessage
        };
        case Types.DELETE_CONTACT:
                  return {
                      ...state, deleteContacts: action.payload.deleteContacts
                  };
                  case Types.TEMPORY_CONTACT_LIST:
                    return {
                      ...state, temporyContact: action.payload.temporyContact,temporyTeamContact:action.payload.temporyTeamContact
                    };
                  
  default:
    return state;
  }
};